// This makes sure that Gravity Form page changes and submissions jump you to the top of the form/confirmation message
document.addEventListener("gform/ajax/post_page_change", (event) => {
	var form_anchor = document.querySelector("#gf_" + event.detail.formId);
	form_anchor.scrollIntoView();
});
